import * as toastr from 'toastr';
import { Validate1TimeGoalValue } from './Validations/Validate1TimeGoalValue';
import { ValidateEventVerb } from './Validations/ValidateEventVerb';
import { ValidateMissingData } from './Validations/ValidateMissingData';
import { ValidateRequiredComment } from './Validations/ValidateRequiredComment';
import { DisplayToastrError } from 'source/app/presentation/Shared/HandleError';

export function ValidateEntry(inputValues: string[]) {
	const [entryText] = inputValues;
	
	const validations: IValidationResult[] = [
		ValidateMissingData(inputValues),
		ValidateEventVerb(entryText),
		Validate1TimeGoalValue(entryText),
		ValidateRequiredComment(entryText),
	]

	const failedValidations = validations
		.filter(validation => !validation.isValid);
	
	const didAllValidationsPass = !failedValidations.length;
	if (didAllValidationsPass) {
		return true;
	} else {
		const firstError = failedValidations[0].errorMessage!
		DisplayToastrError(firstError, `The Game says...`);
		console.error(firstError);
		return false;
	}
}

export interface IValidationResult {
	isValid: boolean;
	errorMessage?: string;
}

export const validResult: IValidationResult = {
	isValid: true
}